export default __webpack_public_path__ + "static/media/girl-about.2f581f1a.jpg";